import React, { useState, useEffect } from 'react'
import { EnvelopeIcon } from '@heroicons/react/24/outline'
import logo from '@images/logo-50px-high-no-strap.png'
import Search from '../search'
import WhatsOnMenu from '../whatson-menu'
import MegaMenu from '../mega-menu'
import BasketStatus from '../basket-status'
import UserMenu from '../user-menu'
import spektrixAuth from '@lib/spektrix/auth'

const TopMenu = () => {
  const [authState, setAuthState] = useState({
    authenticated: false,
    user: null,
    loading: true
  })

  useEffect(() => {
    // Check initial auth status
    spektrixAuth.checkAuthStatus().then(result => {
      setAuthState({
        authenticated: result.authenticated,
        user: result.user,
        loading: false
      })
    })

    // Listen for auth changes
    const cleanup = spektrixAuth.onAuthChange(authData => {
      setAuthState({
        authenticated: authData.authenticated,
        user: authData.user,
        loading: false
      })
    })

    return cleanup
  }, [])

  return (
    <div className='navbar bg-white shadow-sm rounded-lg dark:bg-gray-800 dark:text-white'>
      <div className='flex-1'>
        <a href='/' className='inline-block cursor-pointer'>
          <img src={logo} alt='Logo' className='m-1 sm:m-2 h-6 sm:h-8' />
        </a>
      </div>
      <div className='flex gap-1 sm:gap-2 items-center'>
        <a
          href="/mailing-list/signup"
          className="sm:flex items-center gap-1 px-2 py-1 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors text-sm"
          title="Join our Mailing List"
        >
          <EnvelopeIcon className="w-5 h-5" />
          <span className="hidden md:inline">Join our mailing list</span>
        </a>
        <WhatsOnMenu />
        <Search />
        <BasketStatus iconOnly />
        <div className="hidden sm:block">
          <UserMenu authState={authState} />
        </div>
        <MegaMenu authState={authState} />
      </div>
    </div>
  )
}

export default TopMenu
